// Helper functions for common tracking scenarios
const getTrackingParams = () => {
	if (typeof window === 'undefined' || !window.sessionStorage) {
		return {};
	}

	const trackingKeys = [
		'utm_source',
		'utm_campaign',
		'utm_medium',
		'utm_content',
		'utm_term',
		'mtm_group',
		'CMP',
		'cmp',
	];

	const params = {};

	trackingKeys.forEach((key) => {
		const value = sessionStorage.getItem(key);
		if (value !== null) {
			params[key] = value;
		}
	});

	return params;
};

export const trackPageView = (pageName, additionalData = {}) => {
	if (window.utag) {
		const trackingParams = getTrackingParams();
		window.utag.view({
			page_name: pageName,
			page_type: 'authentication',
			...trackingParams,
			...additionalData
		})
	}
}

export const trackEvent = (event, tealiumEvent, linkText, linkURL, additionalData = {}) => {
	const href = event.currentTarget.href;
	const targetBlank = event.currentTarget.target === '_blank';

	try {
		// Track event with Tealium
		if (typeof window !== 'undefined' && window.utag) {
			window.utag.link({
				tealium_event: tealiumEvent,
				link_text: linkText,
				link_url: linkURL,
				event_page: window.location.href,
				...additionalData,
			});
		}

		// Handle navigation with delay to ensure tracking completes
		setTimeout(() => {
			if (event.ctrlKey || event.metaKey || targetBlank) {
				// Open in new tab (Ctrl/Cmd+Click or target="_blank")
				const newWindow = window.open(href, '_blank');
				if (newWindow) {
					newWindow.focus();
				}
			} else {
				// Navigate in same window
				window.location.href = href;
			}
		}, 200);
	} catch {
		// Fallback: navigate immediately if tracking fails
		window.location.href = href;
	}
};

export const trackButtonEvent = (tealiumEvent, linkText, linkURL, additionalData = {}) => {
	try {
		// Track event with Tealium
		if (typeof window !== 'undefined' && window.utag) {
			window.utag.link({
				tealium_event: tealiumEvent,
				link_text: linkText,
				link_url: linkURL,
				...additionalData,
			});
		}
	} catch {
		console.error('Error tracking Tealium event:', tealiumEvent);
	}
};

export const trackLink = (data) => {
	if (typeof window !== 'undefined' && window.utag) {
		window.utag.link(data);
	}
};
